'use strict';

const _ = require('lodash');
const labels = require('../i18n/en_EN/labels');

class Template {
    constructor () {
        // init labels object (english labels by default)
        this.labels = labels;
        this.supportedLangs = ['es', 'en'];
    }

    /**
     * Selects the template labels language. Loads the default labels for the selected language
     * @param  {string} code Language code
     */
    selectLanguage (code) {
        if (this.supportedLangs.indexOf(code) !== -1) {
            this.labels = _.extend(this.labels, require('../i18n/'+ this.parseLangCode(code) + '/labels'));
        }
    }

    /**
     * Set new labels or override existing ones
     * @param {object} labels Labels object containing label names as keys and strings or template functions as values
     */
    setLabels (labels) {
        // extend the default object
        this.labels = _.extend(this.labels, labels);
    }

    /**
     * Retrieves the specified label, replacing the given variables
     * @param  {string} name   Label name
     * @param  {object} values Label parameters
     * @return {string}        HTML formatted string
     */
    label (name, values) {
        const label = this.labels[name];
        // check if it exists
        if (!label) {
            return false;
        }
        // if values have been passed and label is a function
        if (typeof label === 'function' && values) {
            return label(values);
        }

        return label;
    }

    /**
     * Parse a language code and append the country code (if required)
     * @param  {string} code Language code (e.g. en_EN or en)
     * @return {string}      Full language code (with country suffix)
     */
    parseLangCode (code) {
        switch (code) {
            case 'en':
            case 'en_EN':
                code = 'en_EN';
                break;
            case 'es':
            case 'es_ES':
                code = 'es_ES';
                break;
        }

        return code;
    }
}

module.exports = new Template();


// WEBPACK FOOTER //
// ./src/Template.js